import React from 'react';
import Grid from '../../common/Grid/Grid';
import MeetingCardItem from './MeetingCardItem';

/**
 * MeetingGrid - Virtualized grid for displaying meeting cards
 * Uses the shared Grid component with react-window for performance
 */
const MeetingGrid = ({
  meetings,
  isLoading,
  isLoadingMore,
  pageInfo,
  handleItemClick,
  handleGridScroll,
  showLoadingSpinner,
  shouldHideContent,
  loadMoreData,
  gridRef,
  onView,
  onEdit,
  isUserOwner,
  searchInputValue,
}) => {
  const renderMeetingItem = ({ item, onClick }) => {
    return (
      <MeetingCardItem
        meeting={item}
        onClick={() => onClick(item)}
        onView={onView}
        onEdit={onEdit}
        isOwner={isUserOwner(item)}
      />
    );
  };

  // Dynamic empty state description based on search
  const emptyStateDescription = searchInputValue
    ? "No meetings match your search criteria."
    : "No meetings have been created yet. Click 'New Meeting' to schedule your first check-in.";

  return (
    <Grid
      items={meetings}
      isLoading={isLoading}
      isLoadingMore={isLoadingMore}
      pageInfo={pageInfo}
      renderItem={renderMeetingItem}
      handleItemClick={handleItemClick}
      handleGridScroll={handleGridScroll}
      showLoadingSpinner={showLoadingSpinner}
      shouldHideContent={shouldHideContent}
      loadMoreData={loadMoreData}
      gridRef={gridRef}
      emptyStateTitle="No meetings found"
      emptyStateDescription={emptyStateDescription}
      endOfListMessage="You've reached the end of the list"
      rowHeight={280}
    />
  );
};

export default MeetingGrid;
